/**
 * Format an ISO date string or `Date` into a short human-readable form.
 * Returns an empty string when the input is missing/invalid.
 */
export function formatDate(
  input: string | number | Date | null | undefined,
  locale: string = "en-US"
): string {
  if (input == null) return "";

  const date = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(date.getTime())) return "";

  try {
    return new Intl.DateTimeFormat(locale, {
      year: "numeric",
      month: "short",
      day: "2-digit",
    }).format(date);
  } catch {
    return date.toDateString();
  }
}

export default formatDate;
